import { render, staticRenderFns } from "./p1.vue?vue&type=template&id=38f38460&scoped=true&"
import script from "./p1.vue?vue&type=script&lang=js&"
export * from "./p1.vue?vue&type=script&lang=js&"
import style0 from "./p1.vue?vue&type=style&index=0&id=38f38460&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f38460",
  null
  
)

export default component.exports